import { observer } from 'mobx-react-lite'
import styles from './styles.module.scss'
import { ITabItem, Tabs } from 'components/Tabs/Tabs'
import { useConversationSendMessageContext } from 'widgets/inbox/ConversationSendMessage/context/context'
import { Textarea } from 'components/Textarea/Textarea'

export const ConversationSendMessageUi = observer(() => {
  const { type, setType, smsStore, noteStore } =
    useConversationSendMessageContext()
  const onTabClick = (_: number, item: ITabItem<typeof type>) => {
    setType(item.id)
  }
  return (
    <div className={styles.wrap}>
      <Tabs
        onTabClick={onTabClick}
        activeTabId={type}
        paddingInline={8}
        tabsItems={[
          {
            label: 'SMS',
            id: 'SMS',
          },
          {
            label: 'Note',
            id: 'NOTE',
          },
        ]}
      />
      <div className={styles.content}>
        {type === 'SMS' && <Textarea textareaStore={smsStore} noBorder />}
        {type === 'NOTE' && <Textarea textareaStore={noteStore} noBorder />}
      </div>
    </div>
  )
})
